const strings = {
  catalog: "Каталог",
  about_us: "О нас",
  where_bue: "Где купить",
  contacts: "Контакты",
  fitness_food_factory: "Fitness food factory",
  banner_description:
    "Это молодая команда энтузиастов фитнеса.\n" +
    "Мы разрабатываем и производим качественное \n" +
    "и вкусное спортивное питание без сахара, лишних калорий и углеводов.",
  drink: "Напиток",
  reviews_from_our_clients: "Отзывы наших клиентов",
  faq: "FAQ",
  news: "Новости",
  actions_and_special_offers: "Акции и специальные предложния",
  list_of_stores_branches_dealers: "Список магазинов, филиалов, дилеров",
  documents_and_disclosure: "Документы и раскрытие информации",
  product_catalog: "Каталог продукции",
  services: "Сервисы",
  collagen: "Коллаген",
  isotonics: "Изотоники",
  creatine: "Креатин",
  protein: "Протеин",
  protein_bars: "Протеиновые батончики",
  proteins_jams: "Протеиновые джемы",
  protein_cookie: "Протеиновое печенье",
  bestsellers: "Хиты продаж",
  new: "Новинки",
  products_for_promotion: "Товары по акции",
  add_to_cart: "В корзину",
};

export default strings;
